import { tournamentsAdapter } from "@/lib/adapters/firestore";
import { useQuery } from "@tanstack/react-query";

/**
 * Admin hook for fetching all tournaments for a specific organizer
 *
 * @param organizerId - The ID of the organizer
 * @returns TanStack Query result with tournaments array
 */
export function useOrganizerTournaments(organizerId: string | undefined) {
  return useQuery({
    queryKey: ["organizer-tournaments", organizerId],
    queryFn: async () => {
      if (!organizerId) {
        return [];
      }

      return tournamentsAdapter.getAll({
        filters: [{ field: "organizerId", operator: "==", value: organizerId }],
        orderBy: [{ field: "startsAt", direction: "desc" }],
      });
    },
    enabled: !!organizerId,
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
}
